import { StateCreator } from "zustand";
import { produce } from "immer";
import { STEPS_ENUM } from "./types";
import AnalyticsSender from "@/api/Analytics";
import { wrapStore } from "@/app/store/StoreWrapper";
import { appStore } from "@/app/store/appStore";
interface IStepsStore {
	activeStep: STEPS_ENUM;
	lastStepChangedAt: number;
	setActiveStep: (step: STEPS_ENUM) => void;
}

export const createStepsStore: StateCreator<IStepsStore> = (set) => ({
	activeStep: STEPS_ENUM.EmailStep,
	lastStepChangedAt: Date.now(),
	setActiveStep: (step: STEPS_ENUM) => {
		console.log(`setActiveStep ${step}`);
		const { activeStep, lastStepChangedAt } = stepsStore.getState();
		const appCode = appStore.getState().appCode;

		if (activeStep !== step) {
			void AnalyticsSender.SendChangeState(appCode, 0, activeStep, step, Date.now() - lastStepChangedAt);

			set(
				produce((store: IStepsStore) => {
					store.activeStep = step;
					store.lastStepChangedAt = Date.now();
				})
			);
		}
	}
});

export const stepsStoreWrapper = wrapStore<IStepsStore>();
export const stepsStore = stepsStoreWrapper.withStore(createStepsStore, "steps-store");
